// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Locations_header__KOWVf {\n  margin-bottom: 28px; }\n\n.Locations_flex__3ySiX {\n  display: flex; }\n\n.Locations_sectionTable__2kC7a .ant-collapse-item .ant-collapse-header .ant-collapse-arrow + span {\n  max-width: auto;\n  min-width: auto; }\n", ""]);
// Exports
exports.locals = {
	"header": "Locations_header__KOWVf",
	"flex": "Locations_flex__3ySiX",
	"sectionTable": "Locations_sectionTable__2kC7a"
};
module.exports = exports;
